"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const IconContainer_1 = __importStar(require("../IconContainer"));
const StyledPath = styled_components_1.default.path `
  stroke: ${({ theme, color }) => color || theme.palette.primary.main};
`;
const SearchIconThin = ({ size = IconContainer_1.DEFAULT_ICON_SIZE, color, ...rest }) => ((0, jsx_runtime_1.jsx)("svg", { fill: "none", height: size, viewBox: "0 0 18 22", width: size, xmlns: "http://www.w3.org/2000/svg", ...rest, children: (0, jsx_runtime_1.jsx)(StyledPath, { color: color, d: "M4.43333 10.616C4.14121 9.70078 4.02932 8.69838 4.14229 7.65522C4.47422 4.59593 6.80686 2.10775 9.71083 1.7223C13.9301 1.16308 17.4786 4.89649 16.9471 9.33571C16.5791 12.4086 14.1894 14.8696 11.2623 15.2001C9.74849 15.3705 8.32556 14.9896 7.15385 14.2249C7.02851 14.1434 6.86927 14.1587 6.76544 14.2679L1 20.3333", strokeLinecap: "round", strokeWidth: "2" }) }));
exports.default = (0, IconContainer_1.default)(SearchIconThin);
//# sourceMappingURL=index.js.map